<template>
  <div class="page">
    <div style="text-align: left">
      <el-button
        type="primary"
        plain
        size="medium"
        @click="editLease"
        :disabled="dataInfo.canceled"
        >续约</el-button
      >
      <el-button
        type="warning"
        plain
        size="medium"
        @click="checkOut"
        :disabled="dataInfo.canceled"
        >退房</el-button
      >
      <el-button
        type="danger"
        plain
        size="medium"
        @click="deleteLease"
        :disabled="dataInfo.canceled"
        >{{dleButtonHint}}</el-button
      >
    </div>

    <div class="item-title">房源信息</div>
    <div class="item-line"></div>
    <div class="item-main">
      <div class="div-2">
        <div class="div-2">
          <div class="div-2-title">所属区域：</div>
          <div class="div-2-content">{{ dataInfo.areaName }}</div>
        </div>
        <div class="div-2">
          <div class="div-2-title">房号：</div>
          <div class="div-2-content">{{ dataInfo.houseName }}</div>
        </div>
      </div>
    </div>

    <div class="item-title">租赁信息</div>
    <div class="item-line"></div>
    <div>
      <div style="display: flex;margin-top:20px">
        <div style="display: flex">
          <div class="div-2-title">合同时间：</div> 
          <div v-if="dataInfo.id">{{leaseStart.substring(0,11)}} 至 {{leaseEnd.substring(0,11)}}</div>
        </div>

          <div style="display: flex">
            <div class="div-2-title">总期数：</div>{{dataInfo.totalUnits}}
          </div>
          
        <div style="display: flex">
            <div class="div-2-title">付租方式：</div>{{dataInfo.unit}} 
          </div>
      </div>  
      <div class="div-2 div-2-top" style="justify-content: start;">
        <div class="div-2-title">备注：</div><div>{{dataInfo.comment}} </div>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">租客：</div>
        <div class="div-2-content">
          <el-tag
          size="mini"
          class="tagClass"
            :closable="!dataInfo.canceled"
            @click="editRenter(tag)"
            :key="tag.renterID"
            v-for="tag in dataInfo.renters"
            :disable-transitions="false"
            @close="deleteRenter(tag)"
          >
            {{ tag.renterName }}
          </el-tag>
           <el-tag  class="button-new-tag"  size="mini"  effect="plain" type="info"  @click="addRenter" :disabled="dataInfo.canceled">+ 添加租客</el-tag>
         
        </div>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">合同：</div>
        <div class="div-2-content">
          <el-tag size="mini" class="tagClass" :closable="!dataInfo.canceled"
            @click="editContract(tag)"  :key="tag.id"  v-for="tag in dataInfo.contracts"
            :disable-transitions="false"  @close="deleteContract(tag)"
          >
            {{ tag.name }}
          </el-tag>
          <el-tag   class="button-new-tag"  size="mini"  effect="plain" type="info"  @click="addContract" :disabled="dataInfo.canceled">+ 添加合同</el-tag>
          
        </div>
      </div>
    </div>

    <div class="item-title">收费信息</div>
    <div class="item-line"></div>
    <el-table :data="pricings">
      <el-table-column prop="type" label="项目类型" align="center">
      </el-table-column>
      <el-table-column prop="name" label="项目名称" align="center">
      </el-table-column>
      <el-table-column prop="unit" label="计价单位" align="center">
      </el-table-column>
      <el-table-column label="价格(元)" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.amountStr }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isPostPayStr" label="付费方式" align="center">
      </el-table-column>
      <el-table-column prop="totalUnits" label="总期数" align="center">
      </el-table-column>
      <el-table-column prop="paidUnits" label="已付费期数" align="center">
      </el-table-column>
      <el-table-column prop="comment" label="备注" align="center">
      </el-table-column>
    </el-table>

    <div class="item-title">设施列表</div>
    <div class="item-line"></div>
    <el-table :data="dataInfo.assets">
      <el-table-column prop="name" label="设施名称" align="center">
      </el-table-column>
      <el-table-column prop="price" label="设施金额" align="center">
      </el-table-column>
      <el-table-column prop="amount" label="数量" align="center">
      </el-table-column>
      
    </el-table>

    <el-dialog
      :visible.sync="dialogRenterVisible"
      title="租客信息"
      width="35%"
      :close-on-click-modal="false" 
      :close-on-press-escape="false"
    >
      <div class="div-2">
        <div class="div-2-title">姓名：</div>
        <el-input
          v-model="formRenterInput.renterName"
          :disabled="dataInfo.canceled"
          maxlength="13"
        ></el-input>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">电话号：</div>
        <el-input
          v-model="formRenterInput.renterPhone"
          :disabled="dataInfo.canceled"
          maxlength="11"
        ></el-input>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">证件类型：</div>
        <el-select
          :disabled="dataInfo.canceled"
          v-model="formRenterInput.cardType"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option label="身份证" value="身份证"></el-option>
          <el-option label="工作证" value="工作证"></el-option>
          <el-option label="护照" value="护照"></el-option>
          <el-option
            label="统一社会信用代码"
            value="统一社会信用代码"
          ></el-option>
        </el-select>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">证件号：</div>
        <el-input
          v-model="formRenterInput.cardNum"
          :disabled="dataInfo.canceled"
          maxlength="30"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRenterVisible = false" size="medium"
          >取 消</el-button
        >
        <el-button
          :disabled="dataInfo.canceled"
          type="primary"
          size="medium"
          @click="submitRenter"
          :loading="dialogRenterLoading"
          >{{ dialogRenterLoading ? "提交中..." : " 确 定" }}</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogLeaseVisible"
      :title="dialogLeaseTitle"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="div-2">
        <div class="div-2-title">本期结束时间：</div>
        <el-date-picker
          disabled
          style="width: 100%"
          v-model="formLeaseInput.leaseEnd"
          type="date"
        >
        </el-date-picker>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">续约开始时间：</div>
        <el-date-picker
          :editable="false"
          :clearable="false"
          :picker-options="pickerOptionsLease"
          style="width: 100%"
          v-model="formLeaseInput.leaseStart"
          type="date"
          placeholder="选择开始时间"
        >
        </el-date-picker>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">总期数：</div>
        <el-input
          class="input-with-select"
          v-model.number="formLeaseInput.totalUnits"
          maxlength="3"
        >
          <el-select
            slot="append"
            placeholder="请选择"
            v-model="formLeaseInput.unit"
          >
            <el-option label="月" value="月"></el-option>
            <el-option label="季" value="季"></el-option>
            <el-option label="半年" value="半年"></el-option>
            <el-option label="年" value="年"></el-option>
          </el-select>
        </el-input>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">已付租期数：</div>
        <el-input
          v-model.number="formLeaseInput.paidUnits"
          maxlength="3"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogLeaseVisible = false" size="medium"
          >取 消</el-button
        >
        <el-button
          type="primary"
          size="medium"
          @click="submitLease"
          >{{" 确 定" }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 添加合同 --> 
      <el-dialog title="创建合同" :visible.sync="contractVisible" width="30%" :close-on-click-modal="false">
        <div>
          <el-form ref="formContractInputForm" :model="formContractInput" label-width="80px">
            <el-form-item label="合同名称">
              <div style="width:215px">
                <el-input ref="hetongName" :placeholder="placeholderName" v-model="formContractInput.contractName" 
                :disabled="formContractInput.id?true:false"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="合同类型">
              <div style="width:215px">
                <el-radio-group v-model="formContractInput.contractType"  @change="changeType">
                    <el-radio label="租赁合同">租赁合同</el-radio>
                    <el-radio label="其它合同">其它合同</el-radio> 
                </el-radio-group> 
               </div>
            </el-form-item>
            <el-form-item label="签署方式">
              <div style="width:215px">
                <el-radio-group v-model="formContractInput.signType"  >
                  <div style="display:flex"> 
                       <el-radio label="在线签署" >
                          在线签署  
                          <el-tooltip class="item" effect="dark" content="线上签署电子合同" placement="top-start">
                             <i class="el-icon-info"></i> 
                          </el-tooltip> 
                      </el-radio> 
                      <el-radio label="线下签署">
                          线下签署 
                          <el-tooltip class="item" effect="dark" content="线下签署后上传合同附件" placement="top-start">
                            <i class="el-icon-info"></i>
                          </el-tooltip> 
                      </el-radio>  
                  </div> 
                   
                  </el-radio-group> 
              </div>
            </el-form-item>
             <el-form-item label="状态"  v-if="formContractInput.id">
              <div style="width:215px">
                <el-input v-model="formContractInput.state" :disabled="true"></el-input>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="contractVisible = false">取 消</el-button>
          <el-button type="primary" @click="submiContract"  >确 定</el-button> 
          <div style="margin-top:10px"  v-if="formContractInput.signType=='在线签署'">
              <el-checkbox v-model="checked">
                <div @click="seeXieYi=true" style="color:blue">勾选即表示同意《数字证书使用协议》</div>
              </el-checkbox>
            </div>
        </span>
      </el-dialog>
      <el-dialog :title="formContractInput.name " top="1vh" :visible.sync="seeXieYi" width="90%" :close-on-click-modal="false">
        <iframe style="top: 0px;width:100%; height: 70vh;scrolling:no" src="https://web.hytsmart.com/agreements/ca.html" frameborder="0" ></iframe>
        <span slot="footer" class="dialog-footer">
            <el-button @click="seeXieYi = false">关闭</el-button> 
         </span>
      </el-dialog>
      <!-- 合同详情 -->
      <el-dialog :title="formContractInput.name " top="1vh" :visible.sync="contractVisibleDetail" width="90%" :close-on-click-modal="false">
        <div class="dialogBox">
          <div class="boxItem">
            <div class="left">合同类型:</div>
            <div class="right">{{formContractInput.type}}</div>
          </div>
          <div class="boxItem">
            <div class="left">签署方式:</div>
            <div class="right">{{formContractInput.signType}}</div>
          </div>
          <div class="boxItem">
            <div class="left">状态:</div>
            <div class="right">{{formContractInput.state}}</div>
          </div>
        </div>
        <!--线上 电子合同 -->
        <div v-if="formContractInput.signType=='在线签署'">
          <iframe style=" ;width:100%; height: 65vh;" :src="viewUrl" frameborder="0"></iframe>
        </div>
          <!-- 线下 -->
        <div v-else> 
          <div v-if="formContractInput.state=='待上传'" class="noShangchuan">
            <el-upload :show-file-list="false"  :http-request="uploadSectionFile" class="upload-demo"
              drag :data="uploadData"  :headers="getHeaders()"  :action="uploadUrl" >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </div> 
          <div v-else class="xianxiaTupian">
              <i class="el-icon-notebook-2"></i>
          </div>
        </div>
         <span slot="footer" class="dialog-footer">
            <el-button @click="contractVisibleDetail = false">取 消</el-button>
             <el-button type="primary" @click="handleSign" v-if="formContractInput.signType=='在线签署'">签 署</el-button>
              <el-button type="primary" @click="addItem" v-if="formContractInput.signType=='线下签署'">上传附件</el-button>
              <el-button type="success" @click="downloadFile(formContractInput)" >下载</el-button>
              
         </span>
      </el-dialog>

      <!-- 预览在线合同 --> 
      <el-dialog title="" top="1vh"  :visible.sync="previewVisible" width="90%"  :close-on-click-modal="false">
        <div>
          <iframe style=" ;width:100%; height: 70vh;" :src="viewUrl" frameborder="0"></iframe>
        </div>
        
        <span slot="footer" class="dialog-footer"> 
          <el-button type="primary" @click="refresh" >刷 新</el-button>
          <el-button type="primary" @click="handleSign" >确 认 签 署</el-button> 
        </span>
        
      </el-dialog>
      <!-- 线下签署 -->
      <el-dialog ref="upload" :visible.sync="dialogVisible" title="上传合同" width="40%" :close-on-click-modal="false" :close-on-press-escape="false" >
         <div style="color:red;font-size:12px;margin-bottom:10px">
            注：新上传的文件会覆盖之前的文件
          </div>
        <el-upload :show-file-list="false"  :http-request="uploadSectionFile" class="upload-demo"
          drag :data="uploadData"  :headers="getHeaders()"  :action="uploadUrl" >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </el-dialog>
     <refund  ref="refund" @close="onRefundClose"></refund>
  </div>
</template>

<script>
import axios from "axios";
import { Loading } from "element-ui";
import Utils from "../../Utils";
import Refund from "./Refund";

let leaseStartLimit;
import mixins from "../../minix";

export default {
  name: "home",
  components: { Refund },

  mixins: [mixins],

  computed: {
    leaseStart() {
      return this.getYMDHMS(this.dataInfo.leaseStart * 1000);
    },

    leaseEnd() {
      leaseStartLimit = this.getYMDHMS(this.dataInfo.leaseEnd * 1000);
      return leaseStartLimit;
    },

    leaseTotalStr() {
      return `${this.dataInfo.totalUnits}${this.dataInfo.unit}`;
    },
  },

  data() {
    return {
      dialogRenterTitle: "",
      dialogLeaseTitle: "",
      contractId:'',
      checked:false,
      seeXieYi:false,
      dialogRenterVisible: false,
      contractVisible:false,
      previewVisible:false,
      dialogLeaseVisible: false,
      dialogVisible:false,
      contractVisibleDetail:false,
      
      formContractInput:{},
      formRenterInput: {}, 
      formLeaseInput: {},

      dialogRenterLoading: false,
      dialogLeaseLoading: false,

      pickerOptionsLease: {
        disabledDate(time) {
          return time.getTime() < leaseStartLimit;
        },
      },
      undoDel:false,//取消作废标识，若为true，则表示取消租约的作废操作，恢复为未作废的租约	
      dleButtonHint:"作废",
      dataInfo: {},
      pricings: [],
      uploadData: {
        orgID:"",
        leaseID: "",
      },
       uploadUrl: "",
       viewUrl:'',  //
       previewID:'',
       newDay:'',
       placeholderName:'',
    };
  },

  created() {
    Utils.userInfo.leaseID = this.$route.query.id; 
    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");
    this.newDay = this.getYMDHMS(new Date().getTime()).substring(0,11).replace(/-/g,'');
    this.placeholderName = "租赁合同"+this.newDay;
    this.query();
  },

  methods: {
    // 切换合同类型
    changeType(e){ 
       this.placeholderName = e+this.newDay  
      this.$forceUpdate();
    },
    refresh(){
      this.viewUrl = '';
      this.preview({
            contractID:this.previewID,
            leaseID:Utils.userInfo.leaseID,
            orgID:this.$route.query.orgID,
          })
    },
    // 时间转换
    getYMDHMS(timestamp){
        let time = new Date(timestamp)
        let year = time.getFullYear()
        let month = time.getMonth() + 1
        let date = time.getDate()
        let hours = time.getHours()
        let minute = time.getMinutes()
        let second = time.getSeconds()

        if (month < 10) { month = '0' + month }
        if (date < 10) { date = '0' + date }
        if (hours < 10) { hours = '0' + hours }
        if (minute < 10) { minute = '0' + minute }
        if (second < 10) { second = '0' + second }
        return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
    },
    // 点击上传附件
    addItem() {  
      this.dialogVisible = true;   
      this.uploadData.leaseID = Utils.userInfo.leaseID;
      this.uploadData.orgID = this.$route.query.orgID;
    },

     // 上传附件
    uploadSectionFile(params) { 
      this.$confirm('此操作将会覆盖之前的附件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           const loading = Loading.service({
                lock: true,
                text: "正在请求中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.1)",
              });
           const file = params.file;
            // 根据后台需求数据格式
            const form = new FormData();
            // 文件对象
            form.append("file", file);
            // 本例子主要要在请求时添加特定属性，所以要用自己方法覆盖默认的action

            form.append("leaseID", Utils.userInfo.leaseID);
            form.append("orgID",this.$route.query.orgID);
            form.append("contractID", this.formContractInput.id);
            // 项目封装的请求方法，下面做简单介绍
            this.uploadUrl = axios.defaults.baseURL.replace("/v1/org", "/v2") + "leases/contracts/upload"; 
            axios
              .post(this.uploadUrl, form)
              .then((value) => {
                 loading.close();
                if (value.data.code === 0) { 
                  this.$message.success("上传成功");
                  this.dialogVisible = false; 
                  if(this.contractVisibleDetail){
                      this.getContractDetail(this.contractId)
                  }
                  // this.initQuery();
                  // this.getHetongList()
                   this.query();
                } else {
                  this.$message.error(value.data.message);
                }
              })
              .catch((reason) => {
                this.$message.error(reason.toString());
              })
              .finally(() => {
                 loading.close();
                this.$refs.upload.clearFiles();
              });
          
        }).catch(() => {          
        });
     
    },

      // 下载附件
    async downloadFile(e) {  
       const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });
      let file=""
      let baseURL = axios.defaults.baseURL.replace("/v1/org", "/v2"); 
      await axios({
        method: "POST",
        url: `${baseURL}leases/contracts/download`,
        data: {
          orgID:this.$route.query.orgID,
          leaseID:Utils.userInfo.leaseID,
          contractID:this.formContractInput.id,
        },
      }).then((value) => {
          if(value.data.code==0){ 
             file = value.data.data;  
          }else{
             loading.close();
            this.$message.error(value.data.message)
          }
         
        }) .catch((e) => {
           loading.close();
          this.$message.error(e.toString());
        }); 
        if (file === "") return   // 没有获取到文件名时，不启动下载 
          let base = axios.defaults.baseURL.replace("/v1/org/", ""); 
          let url =""
          if(e.signType=="在线签署"){ 
              window.open(file);
          }else{
            url = `${base}${file}`
          }
          await axios({
            method: "get",
            url: url,
            responseType: "blob",
          }).then((value) => {  
              Utils.convertRes2Blob(file, value);
              this.$message.success("文件下载成功");
            })  .catch((e) => {
              this.$message.error(e.toString());
            }) .finally(() => {
              loading.close();
            }); 
    },

    onRefundClose() { 
      this.query(this.pageIdx-1)
    },
    checkOut() {
      // 调用公共页面及其方法
      this.$refs.refund.checkOutLease(Utils.userInfo.leaseID, this.$route.query.orgID);
    },
    //作废：删除租约
    deleteLease() {
      var hintMsg =""
      var data={}
      if (this.undoDel){
        hintMsg="此操作将恢复当前合同，但是已作废的续约租约不会恢复，如需续约，请重新执行续约操作，"
        data={
              leaseID: Utils.userInfo.leaseID,
              undoDel:true,
            }
      }else{
        hintMsg="此操作将解除当前合同，并作废所有关联的账单以及续约租约，"
        data={
              leaseID: Utils.userInfo.leaseID,
            }
      }
      this.$confirm(hintMsg+"是否继续？","提示",{
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          axios({
            method: "post",
            url: "leases/delete",
            data: data,
          })
            .then((value) => {
              let message = value.data.message;
              if (value.data.code === 0) {
                this.$message.success(message);
                this.query()
              } else {
                this.$message.error(message);
              }
            })
            .catch(() => {
              this.$message.error("操作失败");
            });
        })
        .catch(() => {});
    },

    editLease() {
      if (this.dataInfo.areaName) {
        this.dialogLeaseTitle = `续约【 ${
          this.dataInfo.areaName + "-" + this.dataInfo.houseName
        } 】`;
      } else {
        this.dialogLeaseTitle = `续约【 ${this.dataInfo.houseName} 】`;
      }
      this.formLeaseInput = {
        totalUnits: 0,
        paidUnits: 0,
        unit: "年",
        leaseStart: new Date((this.dataInfo.leaseEnd + 24 * 60 * 60) * 1000),
        leaseEnd: new Date(this.dataInfo.leaseEnd * 1000),
      };
      this.dialogLeaseVisible = true;
    },

    submitLease() {
      let data = { ...this.formLeaseInput };
      data.houseID = this.dataInfo.houseID;
      data.prevLeaseID = Utils.userInfo.leaseID;
      data.leaseStart = this.formLeaseInput.leaseStart.getTime() / 1000;

      const loading = Loading.service({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });

      axios({
        method: "post",
        url: "leases/renew",
        data: data,
      })
        .then((value) => {
          let message = value.data.message;
          if (value.data.code === 0) {
            this.$message.success(message);
            // 刷新数据
            this.query();
            this.dialogLeaseVisible = false;
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(() => {
          loading.close();
        });
    },
    // 签署
    handleSign(){ 
      this.$confirm('已进入安全签约环境，即将调用您的数字证书进行合同签署, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            const loading = Loading.service({
                lock: true,
                text: "加载中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.1)",
              });
            let v2BaseURL = axios.defaults.baseURL.replace("/v1/org", "/v2");
            axios({
              method: "post",
              url: v2BaseURL+"leases/contracts/landlordsign",
              data: {
                leaseID:this.$route.query.id,
                contractID:this.previewID,
                orgID:this.$route.query.orgID
              },
            }).then((value) => {
                let message = value.data.message;
                if (value.data.code === 0) { 
                  this.$message.success("签署成功");
                  if(this.contractVisibleDetail){
                        this.getContractDetail(this.contractId)
                    }
                    // 刷新数据
                  this.query();
                  this.previewVisible = false 
                  this.contractVisible = false;

                } else {
                  this.$message.error(message);
                }
              })
              .catch(() => {
                this.$message.error("操作失败");
              })
              .finally(() => {
                loading.close();
              });
         
        }).catch(() => {          
        });
        
    },
    // 合同弹框确定
    submiContract(){ 
        if(this.formContractInput.contractName=='' ){
          // this.$message.error("请填写合同名称！")
          this.formContractInput.contractName = this.placeholderName;
        }
        if( this.formContractInput.contractType=='' ){
          return this.$message.error("请选择合同类型！")
        }
          if( this.formContractInput.signType==''){
          return this.$message.error("请选择签署方式！")
        }
         if(!this.checked&&this.formContractInput.signType=='在线签署'){
            return this.$message.error('请同意《数字证书使用协议》')
          }
        let data = { ...this.formContractInput };
        data.leaseID = Utils.userInfo.leaseID;
        data.orgID = this.$route.query.orgID; 

        const loading = Loading.service({
          lock: true,
          text: "加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });
      let v2BaseURL = axios.defaults.baseURL.replace("/v1/org", "/v2");
      axios({
        method: "post",
        url: v2BaseURL+"leases/contracts/add",
        data: data,
      }).then((value) => {
        this.checked = false;
          let message = value.data.message;
          if (value.data.code === 0) {
            this.$message.success(message);
            if(this.formContractInput.signType=='线下签署'){
               this.addItem()  
            }else{
              this.previewID = value.data.data;
               this.preview({
                  contractID:value.data.data,
                  leaseID:Utils.userInfo.leaseID,
                  orgID:this.$route.query.orgID,
                })
                this.previewVisible = true 
            }
           this.query();
            this.contractVisible = false;

          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(() => {
          loading.close();
        });
    },
    // 获取电子合同
    preview(e){
       this.viewUrl = "";
        const loading = Loading.service({
          lock: true,
          text: "加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });
       let v2BaseURL = axios.defaults.baseURL.replace("/v1/org", "/v2");
      axios({
        method: "post",
        url: v2BaseURL+"leases/contracts/preview",
        data: e,
      }).then((value) => {
          let message = value.data.message;
          if (value.data.code === 0) { 
            
            this.viewUrl = value.data.data;
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(() => {
          loading.close();
        });
    },
    
    
    // 添加合同
    addContract(){
        this.contractVisible = true;
         this.placeholderName = "租赁合同"+this.newDay;
        this.formContractInput = {
          contractName: "",
          contractType: "租赁合同",
          signType: "",
        };
    },
    
    //点击合同查看详情
    editContract(item) { 
      this.contractId = item.id;
      this.getContractDetail(item.id)
      this.contractVisibleDetail = true;
    },
    // 获取合同详情
    getContractDetail(id){
        let data={
          contractID:id,
          leaseID:this.$route.query.id,
          orgID:this.$route.query.orgID
        }
         const loading = Loading.service({
              lock: true,
              text: "加载中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.1)",
            });
          let v2BaseURL = axios.defaults.baseURL.replace("/v1/org", "/v2");
        axios({
          method: "post",
          url: `${v2BaseURL}leases/contracts/detail`,
          data: data,
        }).then((value) => {
            if (value.data.data) {
              this.formContractInput = value.data.data; 
              if(this.formContractInput.signType=='在线签署'){
                 this.previewID = this.formContractInput.id
                    this.preview({
                        contractID:this.formContractInput.id,
                        leaseID:this.$route.query.id,
                        orgID:this.$route.query.orgID,
                      })
                } 
            }
          })
          .catch((err) => {
            // eslint-disable-next-line no-console 
          })
          .finally(() => {
            loading.close();
          });
    },
    
    //删除合同
    deleteContract(tag) {
      this.$confirm(
        `此操作将删除合同【 ${tag.name} 】, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        const loading = Loading.service({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });
          let v2BaseURL = axios.defaults.baseURL.replace("/v1/org", "/v2");
          axios({
            method: "post",
            url: v2BaseURL+"leases/contracts/delete",
            data: {
              leaseID: Utils.userInfo.leaseID,
              contractID: tag.id,
              orgID:this.$route.query.orgID
            },
          }).then((value) => {
              let message = value.data.message;
              if (value.data.code === 0) {
                this.$message.success("删除成功");
                // 刷新数据
                this.query(); 
              } else {
                this.$message.error(message);
              }
            }).catch(() => {
              this.$message.error("操作失败");
            }).finally(()=>{ 
                loading.close();
            });
        })
        .catch(() => {});
    },



    //删除租客
    deleteRenter(tag) {
      this.$confirm(
        `此操作将删除租客【 ${tag.renterName} 】, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          axios({
            method: "post",
            url: "leases/renters/delete",
            data: {
              leaseID: Utils.userInfo.leaseID,
              renterID: tag.renterID,
            },
          })
            .then((value) => {
              let message = value.data.message;
              if (value.data.code === 0) {
                this.$message.success(message);
                // 刷新数据
                this.query();
                this.dialogRenterVisible = false;
              } else {
                this.$message.error(message);
              }
            })
            .catch(() => {
              this.$message.error("操作失败");
            });
        })
        .catch(() => {});
    },

    //添加租客
    addRenter() {
      this.dialogRenterVisible = true;
      this.formRenterInput = {
        cardType: "身份证",
        renterName: "",
        renterPhone: "",
        cardNum: "",
      };
    },

    //编辑租客
    editRenter(item) {
      this.formRenterInput = { ...item };
      this.dialogRenterVisible = true;
    },

    //添加和编辑提交
    submitRenter() {
      if (this.formRenterInput.renterName.length <= 0) {
        this.$message.error("请输入租客姓名");
        return;
      }
      if (this.formRenterInput.renterPhone.length < 11) {
        this.$message.error("请输入租客手机号");
        return;
      }
      if (this.formRenterInput.cardNum.length <= 0) {
        this.$message.error("请输入租客证件号码");
        return;
      }

      let data = {
        name: this.formRenterInput.renterName,
        phone: this.formRenterInput.renterPhone,
        cardType: this.formRenterInput.cardType,
        cardNum: this.formRenterInput.cardNum,
      };
      data.leaseID = Utils.userInfo.leaseID;

      let url = "leases/renters/add";

      if (this.formRenterInput.renterID) {
        url = "leases/renters/edit";
        data.renterID = this.formRenterInput.renterID;
      }

      this.dialogRenterLoading = true;

      axios({
        method: "post",
        url: url,
        data: data,
      })
        .then((value) => {
          let message = value.data.message;
          if (value.data.code === 0) {
            this.$message.success(message);
            // 刷新数据
            this.query();
            this.dialogRenterVisible = false;
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(() => {
          this.dialogRenterLoading = false;
        });
    },

    //查询信息
    query() {
      let data = {
        leaseID: Utils.userInfo.leaseID,
      };

      const loading = Loading.service({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });

      axios({
        method: "post",
        url: "leases/detail",
        data: data,
      })
        .then((value) => {
          if (value.data.data) {
            this.dataInfo = value.data.data;
            this.pricings = [];
            if(this.dataInfo.state=="已作废"){
              this.undoDel =true
              this.dleButtonHint="取消作废"
            }else{
              this.undoDel =false
              this.dleButtonHint="作废"
            } 
            if (Array.isArray(this.dataInfo.assets)) {
                 this.dataInfo.assets.forEach((item) => {
                      item.price = this.numFormat(item.price / 100)
                 })
            }
            // dataInfo.assets
            if (Array.isArray(this.dataInfo.pricings)) {
              this.dataInfo.pricings.forEach((item) => {
                if (item.name == "水费" || item.name == "电费") {
                  // 处理水电费保留4位小数的问题
                  item.amountStr = this.meterPricing(item.amount / 10000);
                } else {
                  item.amountStr = this.numFormat(item.amount / 100);
                }
                item.isPostPayStr = item.isPostPay ? "后付费" : "预付费";
                this.pricings.push(item);
              });
            }
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console 
        })
        .finally(() => {
          loading.close();
        });
    },
  },
};
</script>

<style>
.xianxiaTupian{
  background-color: #ccc;
  height: 60vh;
  font-size: 250px;
  color: #aaa;
  line-height: 60vh;
}
.noShangchuan{
   background-color: #ccc;
    height: 60vh; 
    display: flex;
    align-items: center;
}
.upload-demo{
  margin: 0 auto;
}
.el-dialog__body {
    padding: 10px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
.dialogBox{
  display: flex;
  justify-content: space-around;  
  margin-bottom: 30px;
}
 .boxItem{
   display: flex; 
  }
  .left{
    color: rgb(40, 86, 211);
    font-size:14px;
    margin-right: 5px;
  }
.el-select .el-input {
  min-width: 80px;
}
.input-with-select {
  background-color: #fff;
}
.el-tag + .el-tag {
  margin-top: 10px;
  margin-left: 10px;
}
.button-new-tag {
  /* margin-top: 10px; */
  margin-left: 10px;
  cursor: pointer;
  /* height: 32px; */
  /* line-height: 30px; */
  /* padding-top: 0; */
  /* padding-bottom: 0; */
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>

<style lang="scss">
@import "../../style.css";

.div-2-title {
  width: 110px !important;
  min-width: 110px !important;
  max-width: 110px !important;
}

.item-title {
  text-align: start;
  font-size: 18px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.item-main {
  box-sizing: border-box;
  padding: 20px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.item-line {
  width: 100%;
  height: 1px;
  background: #f2f2f2;
}
.header {
  margin-top: 80px;
  justify-content: space-around;
}
.header-title {
  text-align: right;
  width: 150px;
 
}
.tagClass{
  cursor: pointer;
  
}
</style>
